module.exports = __webpack_public_path__ + "img/user4.730a967f.png";